import { observer } from 'mobx-react';
import { useEffect, useState } from 'react';
import { createCurrencyField, createRadioField, createSelectField, createTextField, StandardDialog } from '@roc/ui';
import AddPricingEconomicsTier from './pricingEconomicsStepper';
import { Grid } from '@material-ui/core';
import { useStore } from '@roc/client-portal-shared/hooks';
import { CompanyProfileStore } from '../../stores/companyProfileStore';

const createNewTermTierOptions = [
  {
    label: 'Yes',
    value: true,
  },
  {
    label: 'No',
    value: false,
  },
];

export type TermTierSelectionProps = {
  companyProfileStore: CompanyProfileStore
  defaultNewEconomicTier?: boolean
  showRadioField?: boolean
};

export const TermTierSelection = observer(({ companyProfileStore, defaultNewEconomicTier = true, showRadioField = true }: TermTierSelectionProps) => {
  const formStore = companyProfileStore.lenderTermTierEconomicsFormStore;

  useEffect(() => {
    formStore.loadForm({ newEconomicTier: defaultNewEconomicTier })
    if (showRadioField) {
      formStore.setTermTierToDelete(null)
    }
  }, [])

  useEffect(() => {
    if (formStore.getNewEconomicTierValue && showRadioField) {
      formStore.reset()
      formStore.setGetAllBorrowers(true)
      formStore.possibleTierBorrowers.resetAndFetchGridData()
    }
  }, [formStore.getNewEconomicTierValue])

  useEffect(() => {
    if (!formStore.getNewEconomicTierValue && showRadioField) {
      formStore.loadFromStore(formStore.getSelectedTierId)
      formStore.setGetAllBorrowers(false)
      formStore.setTermTierToDelete(formStore.getSelectedTierId)
      formStore.possibleTierBorrowers.resetAndFetchGridData()
    }
  }, [formStore.getSelectedTierId])

  return (
    <Grid container spacing={4}>

      {showRadioField &&
        <Grid item xs={6}>
          {createRadioField({
            label: 'Create a New Economic Tier',
            fieldName: 'newEconomicTier',
            testId: 'newEconomicTier',
            store: formStore,
            options: createNewTermTierOptions,
            row: true,
          })}
        </Grid>
      }

      {formStore.getNewEconomicTierValue ?
        <Grid item xs={6}>
          {createTextField({
            testId: 'createNewTermTier',
            label: '',
            fieldName: 'createNewTermTier',
            placeholder: "Type a Name for New Tier",
            store: formStore,
          })}
        </Grid> :
        <Grid item xs={6}>
          {createSelectField({
            store: formStore,
            testId: 'existingTermTier',
            fieldName: 'existingTermTier',
            label: '',
            placeholder: 'Select an Existing Tier',
            options: formStore.selectTierOptions,
          })}
        </Grid>
      }
      <Grid item xs={6}>
        {createRadioField({
          label: 'Default Tier?',
          fieldName: 'isDefaultTier',
          testId: 'isDefaultTier',
          store: formStore,
          options: createNewTermTierOptions,
          row: true,
        })}
      </Grid>
      <Grid item xs={6}>
        {createRadioField({
          label: 'Disable pricing?',
          fieldName: 'disablePricing',
          testId: 'disablePricing',
          store: formStore,
          options: createNewTermTierOptions,
          row: true,
        })}
      </Grid>
    </Grid>
  );
});

export default TermTierSelection;
